module.exports = __webpack_public_path__ + "images/links/468x60-B.png";